import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  Text,
  Progress,
} from "@chakra-ui/react";
import { GreenTickIcon } from "@root/assets/icons";
import { useCourseManagementContext } from "@root/context/course-management-context";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";
import { useNotification } from "@root/hooks/useNotification";

export const CourseSuccessModal = () => {
  const { isOpenSuccess, onCloseSuccess, progress, setProgress } =
    useCourseManagementContext();
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isOpenSuccess) {
      setProgress(0); // reset every time modal opens

      interval = setInterval(() => {
        setProgress((prev: number) => {
          if (prev >= 100) {
            clearInterval(interval);
            showNotification({
              type: "success",
              message: t("Course published successfully"),
            });
            navigate(ROUTE_NAMES.COURSE_MANAGEMENT);
            return 100;
          }
          return prev + 1;
        });
      }, 30); // ~3 seconds total (30ms * 100)
    }

    return () => {
      clearInterval(interval);
    };
  }, [isOpenSuccess]);

  return (
    <Modal isOpen={isOpenSuccess} onClose={onCloseSuccess} isCentered size="lg">
      <ModalOverlay />
      <ModalContent borderRadius="16px" px="24px" py="32px" bgColor="white">
        <ModalBody>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="16px"
          >
            <GreenTickIcon />
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap="8px"
              maxWidth={380}
              width="100%"
            >
              <Text fontSize="26px" fontWeight={700}>
                {t("courseSuccess.title")}
              </Text>
              <Text
                fontSize="16px"
                fontWeight={400}
                color="#6C757D"
                textAlign="center"
              >
                {t("courseSuccess.subTitle")}
              </Text>
              <Box width="100%" justifyContent="flex-start">
                <Progress
                  value={progress}
                  size="md"
                  width="100%"
                  borderRadius="8px"
                  colorScheme="green"
                />
                <Text fontSize="14px" color="#2F2F34" mt="10px">
                  {t("courseSuccess.publishing")} : {progress}%
                </Text>
              </Box>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
